import { createSlice } from '@reduxjs/toolkit'

import keys from '@/config/keys'

const getInitialEmbedView = () => {
	if (typeof window === 'undefined') return 'full'

	const params = new URLSearchParams(window.location.search)
	const isWidgetDomain = window.location.hostname.endsWith('.widget.elnk.co')
	if (params.get(keys.QUERY_PARAMS.WIDGET) === '1' || isWidgetDomain) {
		return 'widget'
	}

	return 'full'
}

const initialState = {
	renderKey: new Date().valueOf(),
	showFooter: true,
	headerShow: true,
	bannerHeight: `32px`,
	showingBanner: false,
	overlayMenuOnParallaxBG: true,
	firstTimeCallingPageSchema: true,
	baseViewRenderKey: new Date().valueOf(),
	appLocked: false,
	pageLevelAppLockedInfo: null,
	embedView: getInitialEmbedView(),
	embedMetaData: null,
	leaderboardPage: false,
}

/* Store schema level theme config provided by api */
const themeSlice = createSlice({
	name: 'theme',
	initialState,
	reducers: {
		setThemeData(theme, { payload }) {
			return { ...theme, ...payload }
		},
		resetThemeData() {
			return { ...initialState, embedView: getInitialEmbedView() }
		},
	},
})

export const { setThemeData, resetThemeData } = themeSlice.actions

export default themeSlice.reducer
